module.exports = __webpack_public_path__ + "img/zk-icon-setting.3fbf06a2.svg";